import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { Box, Typography, Paper } from '@mui/material';

const WeeklyDonutChart = React.memo(function WeeklyDonutChart({ weekLabel, completed = 0, total = 0, customColors, totalWeeks = 5 }) {
  // Ensure completed and total are numbers and not undefined
  const safeCompleted = typeof completed === 'number' ? completed : 0;
  const safeTotal = typeof total === 'number' ? total : 0;
  
  const data = [
    { name: 'Completed', value: safeCompleted },
    { name: 'Remaining', value: Math.max(0, safeTotal - safeCompleted) }
  ];

  const percentage = safeTotal > 0 ? Math.round((safeCompleted / safeTotal) * 100) : 0;

  return (
    <Paper sx={{ 
      flex: 1,
      minWidth: { xs: 'unset', sm: totalWeeks === 4 ? '180px' : '150px' },
      p: 2,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 1,
      height: '100%'
    }}>
      <Typography 
        variant="subtitle2" 
        sx={{ 
          textAlign: 'center',
          color: customColors?.primary || 'primary.main',
          fontWeight: 'medium',
          fontSize: { xs: '0.8rem', sm: '0.875rem' }
        }}
      >
        {weekLabel}
      </Typography>
      <Box sx={{ 
        width: '100%', 
        height: { xs: 120, sm: totalWeeks === 4 ? 140 : 120 }, 
        position: 'relative' 
      }}>
        <ResponsiveContainer>
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              innerRadius={30}
              outerRadius={42}
              paddingAngle={0}
              dataKey="value"
              startAngle={90}
              endAngle={-270}
            >
              <Cell key="completed" fill={customColors?.primary || '#1B365D'} />
              <Cell key="remaining" fill="#f0f0f0" />
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <Typography
          variant="h5"
          component="div"
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
            fontWeight: 'bold',
            color: customColors?.primary || 'primary.main',
            fontSize: { xs: '1.2rem', sm: totalWeeks === 4 ? '1.5rem' : '1.2rem' }
          }}
        >
          {percentage}%
        </Typography>
      </Box>
      <Typography 
        variant="body2" 
        color="text.secondary"
        sx={{
          fontSize: { xs: '0.75rem', sm: totalWeeks === 4 ? '0.875rem' : '0.75rem' }
        }}
      >
        {safeCompleted} de {safeTotal} hábitos
      </Typography>
    </Paper>
  );
});

export default WeeklyDonutChart;